import { AccordionPanelSlot } from "../accordion.slots";
import { DisclosurePanel as RaDisclosurePanel } from "react-aria-components";
import type { AccordionContentProps } from "../accordion.types";
import { extractStyleProps } from "@/utils";

/**
 * Accordion.Content - The collapsible content area
 *
 * Contains the main content that is shown/hidden when the header is activated.
 *
 * @supportsStyleProps
 */
export const AccordionContent = ({
  children,
  ref,
  ...props
}: AccordionContentProps) => {
  const [styleProps, restProps] = extractStyleProps(props);

  return (
    <AccordionPanelSlot ref={ref} {...styleProps} asChild>
      <RaDisclosurePanel {...restProps}>{children}</RaDisclosurePanel>
    </AccordionPanelSlot>
  );
};

AccordionContent.displayName = "Accordion.Content";
